module.exports = __webpack_public_path__ + "static/media/busy-sound.ec3de3a6.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/audios/busy-sound.mp3
// module id = 2608
// module chunks = 0